import(/* webpackMode: "eager" */ "/codebuild/output/src1091960197/src/apps/webapp/src/app/global-error.tsx");
